<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.SOFTWARE') }}</h3>
        <dl @click="openDebugModal()">
            <dt>{{ l('ABOUT.VERSION') }}</dt>
            <dd>
                {{ eposCommit }}
                ({{ eposBranch }})
            </dd>

            <dt>{{ l('ABOUT.VERSION_BUILT') }}</dt>
            <dd>
                {{ eposBuiltAt }}
            </dd>
        </dl>
    </div>
</template>

<script>
import { container } from '@/container';
import { dateFilter } from '@/vue/filters/dateFilter';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { suppressModalCancelledErrorOrReThrow } from '@/lib/Errors';

export default {
    name: 'AboutVersionSection',

    emits: [
        'close',
    ],

    computed: {
        eposCommit() {
            return container.appConfig.eposCommit.substr(0, 8);
        },

        eposBuiltAt() {
            return dateFilter(container.appConfig.eposVersion, true);
        },

        eposBranch() {
            return container.appConfig.eposBranch;
        },
    },

    methods: {
        openDebugModal() {
            container.vueModalFactory
                .open(MODAL_NAMES__EPOS.DEBUG)
                .then(() => this.$emit('close'))
                .catch(suppressModalCancelledErrorOrReThrow);
        },
    },
};

</script>
